import { Injectable } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpErrorResponse } from '@angular/common/http';
import { CookieService } from 'ngx-cookie-service';
import { Observable, throwError } from 'rxjs';
import { environment } from '../../environments/environment';
import { catchError, map } from 'rxjs/operators';
import { PermissionEvents } from './permission.service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
    constructor(
        private cookies: CookieService,
        private permissionEvents: PermissionEvents
    ) { }

    //Intercept every HTTP request and add Authorization token header
    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        //Get the session token from the cookies
        const sessionToken = this.cookies.get("session-token");
        //If token is found add it to authorization header
        if (sessionToken) req = req.clone({ setHeaders: { Authorization: sessionToken, 'Cache-Control': 'no-cache', Pragma: 'no-cache' } });
        //Add base URL into request URL
        const shouldSkipApiBaseUrl = req.url.includes('/api/resources/icons');
        req = req.clone({
            url: shouldSkipApiBaseUrl ? req.url : environment.apiUrl + req.url
        });
        //Continue with the request
        return next.handle(req).pipe(
            map((event: any) => {

              //Skip response decoding if event body is blob
              if(event.body instanceof Blob){
                return event;
              }

                //Decode specific HTML entities from the responses
                if (event.body) {
                    const bodyStr = this.decodeHTMLEntities(JSON.stringify(event.body));
                    event = event.clone({ body: JSON.parse(bodyStr) })
                }
                return event;
            }),
            catchError((error: HttpErrorResponse) => {
                // Forbidden: the permissions shown may be out of date (e.g. a role was edited)
                if (error?.status === 403) this.permissionEvents.forbidden$.next();
                return throwError(() => error);
            }));
    }

    private decodeHTMLEntities(str: string): string {
        const entities = [
            ['amp', '&'],
            ['lt', '<'],
            ['gt', '>'],
            ['nbsp', ' '],
            ['quot', '\\"'],
            ['#039', '\'']
        ];
        for (let i = 0, max = entities.length; i < max; ++i)
            str = str.replace(new RegExp('&' + entities[i][0] + ';', 'g'), entities[i][1]);
        return str;
    }
}
